export default __webpack_public_path__ + "static/media/upload-images.4063acbf.svg";